// extracted by mini-css-extract-plugin
module.exports = {"addCard":"NewCard_addCard__1zoir","submitButton":"NewCard_submitButton__2rThJ","cancelButton":"NewCard_cancelButton__1BTS1"};